// FIXME: This should be exported from the ra-core package
type CanAccessParams<
  RecordType extends Record<string, any> = Record<string, any>,
> = {
  action: string;
  resource: string;
  record?: RecordType;
};

export const canAccess = <
  RecordType extends Record<string, any> = Record<string, any>,
>(
  role: string,
  params: CanAccessParams<RecordType>,
  /**
   * The configuration is global to every team: editing it is a separate
   * right (sales.can_manage_configuration), not part of being a team admin
   */
  canManageConfiguration: boolean = role === "admin",
) => {
  if (params.resource === "configuration") {
    return canManageConfiguration;
  }

  if (role === "admin") {
    return true;
  }

  // Non admins can't manage the team members nor the team settings
  if (params.resource === "sales" || params.resource === "team_configuration") {
    return false;
  }

  // Finance is restricted to admins (enforced by RLS on the finance_* tables)
  if (params.resource.startsWith("finance")) {
    return false;
  }

  return true;
};
